var host = {
  ydhxg: '/ydhxgtest',
  zbj: '/zbjtest',
  cygp: '/CeshiCaiYuanGuPiao',
  cem: '/cem/test',
  cdn: 'http://ydhxg-cdn.yd.com.cn',
  ydhxgApi: 'http://ydhxg-api.yd.com.cn',
  ydhxgApi8443: 'http://ydhxg-api.yd.com.cn:8443',
  ydhxgApi8089: 'http://ydhxg-api.yd.com.cn:8089',
  ydhxgApi9091: 'http://ydhxg-api.yd.com.cn:9091',
  ydc: 'https://yun.ydtg.com.cn',
  zslxt: 'http://cs.zslxt.com',
  zslxt8089: 'http://cs.zslxt.com:8089',
  zslxt9004: 'http://cs.zslxt.com:9004',
  zslxtSecure: 'https://cs.zslxt.com:9008',
  hxgApi: 'https://cs-hxg-api.zslxt.com',
  ydtg: 'https://ydtg.com.cn',
  hxgweb: 'http://ydhxg-web.yd.com.cn',
  yd: 'https://www.yd.com.cn',
  ydlog: 'http://ydlog-api.yd.com.cn',
  tdtg9995: 'https://csnewzbj.ydtg.com.cn:9995'
};
// 正式环境
if (process.env.NODE_ENV === 'production' && process.env.APP_ENV == 'prod') {
  var testConfig = {
    ydhxg: '/ydhxg',
    zbj: '/zbj',
    cygp: '/CaiYuanGuPiao',
    cem: '/cem',
    cdn: 'https://ydhxg-prod-cdn.yd.com.cn',
    ydhxgApi: 'https://ydhxg-prod-api.yd.com.cn',
    ydhxgApi8443: 'https://ydhxg-prod-api.yd.com.cn',
    ydhxgApi8089: 'https://ydhxg-prod.yd.com.cn',
    ydhxgApi9091: 'https://ydhxg-prod-admin.yd.com.cn/api',
    ydc: 'https://yun.ydtg.com.cn',
    zslxt8089: 'https://ydgpapp.zslxt.com/web',
    zslxt9004: 'https://home.ydtg.com.cn',
    zslxtSecure: 'https://cem.zslxt.com:8443',
    hxgApi: 'https://hxg-api.yd.com.cn',
    ydtg: 'https://ydtg.com.cn',
    hxgweb: 'https://ydhxg-prod-web.yd.com.cn',
    yd: 'https://www.yd.com.cn',
    ydlog: 'http://ydlog-api.yd.com.cn',
    tdtg9995: 'https://zbj-api.ydtg.com.cn',
  };
  host = Object.assign(host, testConfig);
}
export default host;



// WEBPACK FOOTER //
// ./src/api/host.js